import { render, staticRenderFns } from "./SubtitleBlock.vue?vue&type=template&id=196ff8e6&"
import script from "./SubtitleBlock.vue?vue&type=script&lang=js&"
export * from "./SubtitleBlock.vue?vue&type=script&lang=js&"
import style0 from "./SubtitleBlock.vue?vue&type=style&index=0&id=196ff8e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports